import { ComponentInstance, NodeRedFlow, View } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';

function getIds(comp: ComponentInstance, include: 'inner' | 'outer' | 'all') {
  const ids: string[] = [];
  if (include !== 'inner') {
    ids.push(comp.id);
  }
  if (include !== 'outer') {
    ids.push(`${comp.id}:isolated`);
    comp.children.forEach((child) => {
      const moreIds = getIds(child, 'all');
      ids.push(...moreIds);
    });
  }
  return ids;
}

/**
 * Returns all logic flow nodes related to the given component instance
 * from the given DOLAN view.
 *
 * @param component component instance
 * @param view view
 * @param include whether to include inner/outer/both logic flows
 * @returns logic flows related to the component
 */
export default function getComponentInstanceLogicFlowsFromView(
  component: ComponentInstance,
  view: View,
  include: 'inner' | 'outer' | 'all',
): NodeRedFlow[] {
  // NOTE: This implementation is directly moved from the old ComponentUtils AngularJS service as-is!
  const containedIds = getIds(component, include);
  const pageFlowId = `page:${view.id}`;
  const pageFlowIds = containedIds.map((id) => `${pageFlowId}:component:${id}`);
  return Object.values(view.flows).filter(
    (flow) => pageFlowIds.includes(flow.id) || ('z' in flow && pageFlowIds.includes(flow.z)),
  );
}
